var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 3.05176e-05H2C0.9 3.05176e-05 0 0.90003 0 2.00003V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V2.00003C18 0.90003 17.1 3.05176e-05 16 3.05176e-05ZM4.5 15C3.67 15 3 14.33 3 13.5C3 12.67 3.67 12 4.5 12C5.33 12 6 12.67 6 13.5C6 14.33 5.33 15 4.5 15ZM4.5 6.00003C3.67 6.00003 3 5.33003 3 4.50003C3 3.67003 3.67 3.00003 4.5 3.00003C5.33 3.00003 6 3.67003 6 4.50003C6 5.33003 5.33 6.00003 4.5 6.00003ZM9 10.5C8.17 10.5 7.5 9.83003 7.5 9.00003C7.5 8.17003 8.17 7.50003 9 7.50003C9.83 7.50003 10.5 8.17003 10.5 9.00003C10.5 9.83003 9.83 10.5 9 10.5ZM13.5 15C12.67 15 12 14.33 12 13.5C12 12.67 12.67 12 13.5 12C14.33 12 15 12.67 15 13.5C15 14.33 14.33 15 13.5 15ZM13.5 6.00003C12.67 6.00003 12 5.33003 12 4.50003C12 3.67003 12.67 3.00003 13.5 3.00003C14.33 3.00003 15 3.67003 15 4.50003C15 5.33003 14.33 6.00003 13.5 6.00003Z",
    fill: "#F4EEEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDice);
export default __webpack_public_path__ + "static/media/dice.19d55327393185114cbff446423ca391.svg";
export { ForwardRef as ReactComponent };